import React from 'react';
import { Box, Typography } from '@mui/material';
import { palette } from '../../styles/theme';

export function WidgetAddress ({ title, value, valueColor = palette.bronze.main, width }) {
    return (
        <Box display='flex' padding='8px 0px' flexDirection='column' justifyContent='center' alignItems='flex-start' gap='8px' width={width} height='58px' style={{ borderBottom: `solid 1px ${palette.disabled[300]}` }}>
            <Typography color={palette.disabled[950]}>{title}</Typography>
            <Typography variant='h4' color={valueColor} >{value}</Typography>
        </Box>
    );
}
